<template>
  <div>
    <set-banner-create-edit-form isEdit />
  </div>
</template>

<script>
  import SetBannerCreateEditForm from '../create-set-banner/components/SetBannerCreateEditForm.vue';

  // import useCreateSetBanner from './hooks/useCreateSetBanner';
  export default {
    components: {
      SetBannerCreateEditForm,
    },

    setup() {},
  };
</script>

<style></style>
